// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5731) return "static/chunks/5731-494bd2fe3c285e73.js";
	if (chunkId === 9774) return "static/chunks/framework-9ae9e5844ca20827.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"3616":"dee536d91d8a6db0","3756":"38e613d77b0db689","5772":"d3f4e8fda574b41a","5950":"62e41a4d3e53f407","6239":"1fcccefd06df10b3","7523":"fffed8556e8b4189","7538":"b51fd8e272e4b1cd","8016":"371d343e56e93972","8586":"56ea6abb021e566e","9983":"f0c1cb97a329b9d5"}[chunkId] + ".js";
};